<div class="my_content">
    <h4 class="mb-3" *ngIf="!permissions.analyst_dashboard && !permissions.manager_dashboard">
        Bem-vindo(a) ao Atende!
    </h4>
    <ng-container *ngIf="permissions.analyst_dashboard || permissions.manager_dashboard">
        <div class="container-fluid mt-2">
            <div class="card shadow-sm rounded mb-3 p-3">
                <div class="row g-3 align-items-end">
                    <div class="col-md-3" *ngIf="permissions.manager_dashboard">
                        <label class="form-label fw-semibold">Analista</label>
                        <select class="form-select" [(ngModel)]="analyst">
                            <option value="">Todos</option>
                            <option *ngFor="let item of responsibles" [value]="item.id">{{item.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label class="form-label fw-semibold">Status</label>
                        <select class="form-select" [(ngModel)]="status">
                            <option value="">Todos</option>
                            <option value="7">Contrato Emitido</option>
                            <option value="9">Contrato Cancelado</option>
                            <option value="603">Cancelada</option>
                            <option value="604">Recusada</option>
                            <option value="1270007">Pendente Análise</option>
                            <option value="1270008">Analisado com Pendências</option>
                            <option value="1270010">Aprovada</option>
                            <option value="1270011">Proposta Inativa</option>
                            <option value="1270012">Retorno de Pendência</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label class="form-label fw-semibold">Data Inicial</label>
                        <input class="form-control" type="date" [(ngModel)]="startDate"
                            [value]="startDate | date:'yyyy-MM-dd'" (change)="verifyDateFilters()">
                    </div>
                    <div class="col-md-2">
                        <label class="form-label fw-semibold">Data Final</label>
                        <input class="form-control" type="date" [(ngModel)]="endDate" (change)="verifyDateFilters()">
                    </div>
                    <div class="col-md-1">
                        <button class="btn btn-primary w-100 d-flex align-items-center justify-content-center" (click)="setCharts()">
                            <i class="ri-search-line me-1"></i> Buscar
                        </button>
                    </div>
                </div>
            </div>
            <hr class="my-3">
            <h4 class="mb-3 fw-bold text-primary">
                <i class="ri-bar-chart-2-line me-2"></i>
                Dashboard Atende
            </h4>
            <div class="tabs-wrapper position-relative mb-2" style="z-index: 10;">
                <ul class="nav nav-tabs mt-4">
                    <li class="nav-item">
                        <a class="nav-link" [ngClass]="{'active': page == 1}" (click)="setPage(1)">Estoque</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [ngClass]="{'active': page == 2}" (click)="setPage(2)">Produtividade</a>
                    </li>
                </ul>
            </div>

            <div *ngIf="(inventoryDataIsLoaded() && inventoryDataIsEmpty() && page == 1) || (productivityDataIsLoaded() && productivityDataIsEmpty() && page == 2)" class="no-data-wrapper">
                <div class="no-data-card">
                    <div class="no-data-icon mb-2">
                        <!-- SVG de gráfico vazio -->
                        <svg width="48" height="48" fill="none" viewBox="0 0 48 48"><rect x="8" y="20" width="6" height="16" rx="2" fill="#b0b8c1"/><rect x="21" y="12" width="6" height="24" rx="2" fill="#b0b8c1"/><rect x="34" y="28" width="6" height="8" rx="2" fill="#b0b8c1"/><rect x="6" y="40" width="36" height="2" rx="1" fill="#d1d5db"/></svg>
                    </div>
                    <div class="no-data-text fw-semibold">Nenhum dado encontrado</div>
                    <div class="no-data-subtext">Ajuste os filtros ou o período para visualizar informações.</div>
                </div>
            </div>

            <!-- DASHBOARDS DE ESTOQUE -->
            <ng-container *ngIf="page == 1 && !(inventoryDataIsLoaded() && inventoryDataIsEmpty())">
                <ng-container *ngIf="inventoryDataIsLoaded()">
                    <div class="row g-3">
                        <div class="col-12">
                            <div class="card bg-light mb-2 shadow-sm rounded-4 border-0 custom-chart-card">
                                <div class="card-body w-100">
                                    <div class="row d-flex flex-row justify-content-around align-items-center">
                                        <div class="col-md-7 mb-3 mb-md-0">
                                            <div class="chart-container p-3 rounded-4 border custom-chart-border">
                                                <app-chart [dataSet]="statusDataSet" [colors]="['#192753']" type="bar"
                                                    variation="horizontal"></app-chart>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="chart-container p-3 rounded-4 border custom-chart-border">
                                                <app-chart [dataSet]="auctionDataSet"
                                                    [colors]="['#189918', '#8fdb00', '#f3ea38', '#d10a32', '#192753']"
                                                    type="doughnut" [displayLegend]="true"></app-chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row g-3">
                        <div class="col-12">
                            <div class="card bg-light shadow-sm rounded-4 border-0 custom-chart-card">
                                <div class="card-body">
                                    <div class="row d-flex flex-row justify-content-around align-items-center">
                                        <div class="col-md-3 mb-3 mb-md-0">
                                            <div class="chart-container p-3 rounded-4 border custom-chart-border">
                                                <app-chart [dataSet]="typeDataSet" [colors]="['#192753']" type="bar"></app-chart>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="chart-container p-3 rounded-4 border custom-chart-border">
                                                <app-chart [dataSet]="monthDataSet" [colors]="['#192753']" type="line"></app-chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!inventoryDataIsLoaded()">
                    <div class="loader">
                        <div class="loader-chart-icon">
                            <svg class="loader-chart-svg" viewBox="0 0 56 56" fill="none">
                                <rect class="loader-chart-border" x="3" y="3" width="50" height="50" rx="12" />
                                <rect class="chart-bar" x="14" y="26" width="6" height="16" rx="2" fill="#b0b8c1"/>
                                <rect class="chart-bar" x="25" y="14" width="6" height="28" rx="2" fill="#b0b8c1"/>
                                <rect class="chart-bar" x="36" y="34" width="6" height="8" rx="2" fill="#b0b8c1"/>
                                <rect class="chart-bar" x="12" y="44" width="32" height="2" rx="1" fill="#d1d5db"/>
                            </svg>
                            <span class="loader-chart-loading">Carregando dados...</span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <!-- DASHBOARDS DE PRODUTIVIDADE -->
            <ng-container *ngIf="page == 2 && !(productivityDataIsLoaded() && productivityDataIsEmpty())">
                <ng-container *ngIf="loadedData.analysisTimeData && loadedData.averageAnalysisTimeData">
                    <div class="row g-3">
                        <div class="col-12">
                            <div class="card bg-light mb-2 shadow-sm rounded-4 border-0 custom-chart-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card bg-light mb-3 rounded-4 border-0">
                                                <div class="card-body">
                                                    <h1 class="text-center">Tempo médio</h1>
                                                    <h2 class="text-center" style="color: #192753">{{averageTime}}</h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row d-flex flex-row justify-content-around align-items-center">
                                        <div class="col-md-6 mb-3 mb-md-0">
                                            <div class="chart-container p-3 rounded-4 border custom-chart-border">
                                                <app-chart [dataSet]="analysisTimeDataSet" type="line"
                                                    [displayLegend]="true"></app-chart>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="chart-container p-3 rounded-4 border custom-chart-border">
                                                <app-chart [dataSet]="averageAnalysisTimeDataSet" type="line"
                                                    [colors]="['#192753']"></app-chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="!loadedData.analysisTimeData || !loadedData.averageAnalysisTimeData">
                    <div class="loader">
                        <div class="loader-chart-icon">
                            <svg class="loader-chart-svg" viewBox="0 0 56 56" fill="none">
                                <rect class="loader-chart-border" x="3" y="3" width="50" height="50" rx="12" />
                                <rect class="chart-bar" x="14" y="26" width="6" height="16" rx="2" fill="#b0b8c1"/>
                                <rect class="chart-bar" x="25" y="14" width="6" height="28" rx="2" fill="#b0b8c1"/>
                                <rect class="chart-bar" x="36" y="34" width="6" height="8" rx="2" fill="#b0b8c1"/>
                                <rect class="chart-bar" x="12" y="44" width="32" height="2" rx="1" fill="#d1d5db"/>
                            </svg>
                            <span class="loader-chart-loading">Carregando dados...</span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
</div>